import React from 'react';

function FilterIcon() {

	return (
		<div className="filter-bar-icon">
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path stroke="#326C90" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6"/></svg>
		</div>
	);
}
export default FilterIcon;
